import styled from 'styled-components';

interface StepProps {
  children: React.ReactNode;
  className?: string;
}

export const StepFormat = styled.li`
  font-weight: bold;
  position: relative;
  line-height: 2;
  margin-bottom: 5px;
  &::before {
    content: counter(counter);
    counter-increment: counter;

    display: inline-block;
    box-sizing: content-box;
    border-radius: 10%;
    width: 20px;
    line-height: 1.2em;
    text-align: center;
    font-size: 15px;
    background-color: rgb(100, 100, 100);
    color: white;
    margin-right: 5px;
  }
`;

export const Step = (props: StepProps) => {
  const { className, children } = props;

  return <StepFormat className={className}>{children}</StepFormat>;
};
